import { useTranslation } from '@packages/utils';
import { TRtkErrorType } from 'data/types/generic.types';
import { Modal } from 'components/Base/Modal';
import {
  ENotificationType,
  useShowToastNotification,
} from 'components/Base/Notification';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import { useDeleteOrganizationNoteMutation } from 'redux/apiSlice/organizations.slice';
import { TDeleteDetailsModalProps } from './DeleteDetailsModal.types';
import { addDetailsSectionKey } from '../../../AddDetailsSection.data';

const DeleteDetailsModal = ({
  open,
  setOpen,
  organizationId,
  organizationNoteId,
}: TDeleteDetailsModalProps) => {
  const { t } = useTranslation({
    keyPrefix: `${addDetailsSectionKey}.modals.delete`,
  });
  const { showToastNotification } = useShowToastNotification();
  const [deleteOrganizationNote, { isLoading }] =
    useDeleteOrganizationNoteMutation();

  const handleSubmit = async () => {
    try {
      await deleteOrganizationNote({
        organizationId,
        organizationNoteId,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
      setOpen(false);
    } catch (err) {
      showToastNotification({
        message: (err as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Modal
      title={t('TITLE')}
      open={open}
      onCancel={() => setOpen(false)}
      onOk={handleSubmit}
      okText={t('SUBMIT_BTN')}
      confirmLoading={isLoading}
    >
      <ConfirmModalBody description={t('DESCRIPTION_CONFIRM')} />
    </Modal>
  );
};

export default DeleteDetailsModal;
